import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router';
import AuthGuard from './components/AuthGuard';
import DashboardLayout from './components/dashboard/DashboardLayout';
import DashboardRedirect from './components/dashboard/DashboardRedirect';
import GuestGuard from './components/GuestGuard';
import LoadingScreen from './components/LoadingScreen';
import MainLayout from './components/MainLayout';
import UserAdminContainer from './pages/userAdmin/userAdminContainer';
import VendorBoothContainer from './pages/vendorBooth/venderBoothContainer';
import PimDataContainer from './pages/pimData/pimDataContainer';
import BulkUserUpload from './pages/bulkUserUpload/bulkUserUpload';
import ReportsContainer from './pages/reports/reportsContainer';

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

const VendorSettings = Loadable(lazy(() => import('./pages/vendorSettings/VendorSettings')));

// Authentication pages

const Login = Loadable(lazy(() => import('./pages/authentication/Login')));
const ResetPassword = Loadable(lazy(() => import('./pages/authentication/ResetPassword')));

// Dashboard pages

const Overview = Loadable(lazy(() => import('./pages/dashboard/Overview')));
const Settings = Loadable(lazy(() => import('./pages/Settings')));

// Error pages

const AuthorizationRequired = Loadable(lazy(() => import('./pages/AuthorizationRequired')));
const NotFound = Loadable(lazy(() => import('./pages/NotFound')));
const ServerError = Loadable(lazy(() => import('./pages/ServerError')));

const routes: RouteObject[] = [
  {
    element: '',
    path: 'authentication',
    children: [
      {
        path: 'login',
        caseSensitive: false,
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        ),
      },
      {
        path: 'login-unguarded',
        element: <Login />,
        caseSensitive: false,
      },
    ],
    caseSensitive: false,
  },
  {
    path: 'login/reset',
    element: (
      <GuestGuard>
        <ResetPassword />
      </GuestGuard>
    ),
    caseSensitive: false,
  },
  {
    path: '',
    element: <MainLayout />,
    children: [
      {
        path: '/:vendorNumber',
        element: (
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        ),
        children: [
          {
            path: '/:vendorNumber/VendorBooth',
            element: <VendorBoothContainer />,
            caseSensitive: false,
          },
          {
            path: '/:vendorNumber/PimData',
            element: <PimDataContainer />,
            caseSensitive: false,
          },
          {
            path: '/:vendorNumber/',
            element: (
              <div className="overview">
                <Overview />
              </div>
            ),
            caseSensitive: false,
          },
          {
            path: '/:vendorNumber/UserAdmin',
            element: <UserAdminContainer />,
            caseSensitive: false,
          },
          {
            path: '/:vendorNumber/reports',
            element: <ReportsContainer />,
            caseSensitive: false,
          },
        ],
        caseSensitive: false,
      },
      {
        path: '/BulkUserUpload',
        element: <BulkUserUpload />,
        caseSensitive: false,
      },
      {
        path: '/VendorSettings',
        element: (
          <AuthGuard>
            <VendorSettings />
          </AuthGuard>
        ),
        caseSensitive: false,
      },
      {
        path: '/',
        element: (
          <AuthGuard>
            <DashboardRedirect />
          </AuthGuard>
        ),
        caseSensitive: false,
      },
      {
        path: '/Account',
        element: (
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        ),
        children: [
          {
            path: 'Settings/',
            element: <Settings />,
            caseSensitive: false,
          },
        ],
        caseSensitive: false,
      },
      {
        path: '401',
        element: <AuthorizationRequired />,
        caseSensitive: false,
      },
      {
        path: '404',
        element: <NotFound />,
        caseSensitive: false,
      },
      {
        path: '500',
        element: <ServerError />,
        caseSensitive: false,
      },
      {
        path: '*',
        element: <NotFound />,
        caseSensitive: false,
      },
    ],
    caseSensitive: false,
  },
];

export const navItems = [
  {
    name: 'Dashboard',
    path: '/',
    element: (
      <div className="overview">
        <Overview />
      </div>
    ),
  },
  {
    name: 'Virtual Booth',
    path: '/vendorBooth',
    children: [{}],
  },
  {
    name: 'Users',
    path: '/userAdmin',
    children: [{}],
  },
  {
    name: 'Reports',
    path: '/reports',
    children: [{}],
  },
  // {
  //   name: 'PIM Data',
  //   path: '/pimData',
  //   children: [{}],
  // },
];

export default routes;
